<template>
  <app-dialer-common-popup
    class="app-dialer-info-popup"
    :title="$t('hitl.modules.dialer.info-popup-title')"
    @close="$emit('close')"
  >
    <!-- eslint-disable vue/no-v-html -->
    <div
      class="description"
      v-html="content"
    />
  </app-dialer-common-popup>
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';

import AppDialerCommonPopup from '../../components/common/AppDialerCommonPopup.vue';
import { useDialerStore } from '../../composables';
import { markdownToHTML } from '@/common';

export default defineComponent({
  name: 'AppDialerInfoPopupContainer',
  components: {
    AppDialerCommonPopup,
  },
  emits: ['close'],
  setup() {
    const { description } = useDialerStore();
    return { description };
  },
  computed: {
    content(): string {
      return markdownToHTML(this.description);
    },
  },
});
</script>

<style lang="scss" scoped>
.app-dialer-info-popup {
  min-width: 15.625rem;

  .description {
    margin: 0 1.5rem 1.5rem;
  }
}
</style>
